// Utility to fetch highlightedWords from 00-Home.json
export async function getHighlightedWords(language = 'en') {
  try {
    const resp = await fetch('/descriptions/00-Home.json');
    const data = await resp.json();
    const item = Array.isArray(data) ? data[0] : data;
    return item?.highlightedWords?.[language] || '';
  } catch {
    return '';
  }
}
